
import {defineComponent} from 'vue'
import axios from 'axios'
import {
  defaultHeadersExpertValidation,
  getUserRecordsValidationURL,
  lookupURL,
  scrollToTop,
  validateRecordURL
} from "@/config/app-settings";
import DataTable from "primevue/datatable";
import {FilterMatchMode} from "primevue/api";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import Message from "primevue/message";
import InputText from "primevue/inputtext";
import Column from "primevue/column";
import MultiSelect from "primevue/multiselect";
import FormLegend from "@/components/legend/FormLegend.vue";
import Image from 'primevue/image';
import Dialog from 'primevue/dialog';
import {debounce} from "lodash";


export default defineComponent({
  name: 'ExpertValidation',
  components: {FormLegend, DataTable, MultiSelect, Message, Button, Dropdown, InputText, Column, Image, Dialog},
  data() {
    return {
      loading: false,
      totalRecords: 0,
      lazyParams: {},
      features: [] as any[],
      validationRecordsSelected: {} as { [key: number]: boolean; },
      validationRecordsAdmComment: {} as { [key: number]: string; },
      validationRecordsAppUserComment: {} as { [key: number]: string; },
      selectedValidationRecordHeaders: [] as any[],
      allHeaders: {} as any,
      headers: [] as any[],
      admValidationStatusOptions: null,
      selectedValidationState: 2 as number,
      validationRecords: {} as { [key: string]: any; },
      selectedRecords: [] as any[],
      recordsWithErrors: [] as any[],
      state: 'init' as 'init' | 'submitted' | 'success' | 'error',
      showMessages: false as Boolean,
      showImage: false as Boolean,
      inputText: '' as string,
      img: '' as any,
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }

    }
  },
  computed: {
    isLoggedIn(): Boolean {
      return this.$store.getters.loggedIn;
    },
    errors(): any {
      return this.$store.state.errors
    },
    lang(): String {
      return this.$store.state.language
    }
  },
  watch: {
    errors() {
      if (this.errors.records) {
        for (let [key, value] of Object.entries(this.errors.records)) {
          this.recordsWithErrors.push(key)
        }
      }
    },
    lang() {
      this.loadData()
    },
    inputText() {
      this.onFilter()
    },
    selectedValidationRecordHeaders() {
      defaultHeadersExpertValidation.forEach((el, i) => {
        if (!this.selectedValidationRecordHeaders.some(e => e.header === el.header)) {
          this.selectedValidationRecordHeaders.splice(i, 0, {name: el.name, header: el.header});
        }
      })
      this.$store.commit('setSelectedValidationRecordHeaders', this.selectedValidationRecordHeaders)
    }
  },
  mounted() {
    this.showMessages = false
    this.loading = true;
    const refTable: any = this.$refs.ExpertValidationRecordsTable

    this.lazyParams = {
      first: 0,
      rows: refTable.rows,
      page : 0,
/*      sortField: null,
      sortOrder: null,*/
      filters: this.filters
    };

    this.getAdmValidationStatus()
    this.loadData()

  },
  methods: {
    onlyUnique(value: any, index: any, self: any) {
      return self.indexOf(value) === index
    },
    addAdmComment(record_id: number, value: any) {
      this.validationRecordsAdmComment[record_id] = value
    },
    addUserComment(record_id: number, value: any) {
      this.validationRecordsAppUserComment[record_id] = value
    },
    toggleImage(img: any) {
      this.img = img
      this.showImage = !this.showImage
    },
    loadData() {
      this.loading = true
      axios.post(getUserRecordsValidationURL,this.lazyParams )
          .then(res => {
            console.log(res);
            this.features = res.data.content.filter(this.onlyUnique)
            this.headers = this.features[0] ? Object.keys(this.features[0]) : []
            this.totalRecords = res.data.totalElements
            this.initializeEditableFields()
            this.loadAvailableHeaders()
            this.loading = false
          })
          .finally(() => this.loading = false)
    },
    loadAvailableHeaders() {
      this.allHeaders = this.headers.map(h => {
        return {name: 'table.' + h, header: h}
      })

      // ignore fixed columns for dropdown selection
      this.allHeaders = this.allHeaders.filter((el: any) => el.header !== "ADM_COMMENT" && el.header !== "APP_USER_COMMENT");

      // load headers from browser session, or restore default headers if a new version has been deployed
      this.selectedValidationRecordHeaders = (this.$store.state.selectedValidationRecordHeaders && this.$store.state.selectedValidationRecordHeaders.every((el: any) => this.headers.includes(el.header))) ? this.$store.state.selectedValidationRecordHeaders : this.headers.map((h: any) => {
        return {name: 'table.' + h, header: h}
      })

      // initialize columns with default all available headers
      if (this.selectedValidationRecordHeaders.length == 0) {
        // @ts-ignore
        this.selectedValidationRecordHeaders = this.headers.map((h: any) => {
          return {name: 'table.' + h, header: h}
        })
      }

    },
    showColumn(column: string) {
      if (this.selectedValidationRecordHeaders.map((e: any) => {
        return e.header
      }).includes(column)) {
        return true
      } else {
        return false
      }
    },
    initializeEditableFields() {
      for (const i in this.features) {
        // initialize unchecked checkboxes for selectAll functionality
        let recordId = this.features[i].RECORD_ID

        this.validationRecordsSelected[recordId] = false
        this.validationRecordsAdmComment[recordId] = this.features[i].ADM_COMMENT
        this.validationRecordsAppUserComment[recordId] = this.features[i].APP_USER_COMMENT
      }
    },

    getAdmValidationStatus() {
      axios.get(lookupURL + 'adm_validation_status?lang=' + this.$store.state.language)
          .then(res => this.admValidationStatusOptions = res.data)
          .catch(e => console.log(e))
    },
    save() {
      this.showMessages = false

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      let records = new Map()
      for (const rec in this.selectedRecords) {
        const data = {
          recordId: this.selectedRecords[rec].RECORD_ID,
          admValidationStatus: this.selectedValidationState,
          admComment: this.validationRecordsAdmComment[this.selectedRecords[rec].RECORD_ID],
          appUserComment: this.validationRecordsAppUserComment[this.selectedRecords[rec].RECORD_ID]
        }
        records.set(data.recordId, data)
      }
      this.selectedRecords = []


      let dataMap = {records: {}}
      dataMap.records = Object.fromEntries(records);
      this.recordsWithErrors = []
      axios.put(validateRecordURL, JSON.stringify(dataMap), config)
          .then((res) => {
            this.loadData()
            this.state = 'success'
                this.showMessages = true
                this.$store.dispatch('validate', {})
              }
          ).catch(err => {
        this.state = 'error'
        this.$store.dispatch('validate', err.response.data)
        this.showMessages = true

      })

    },
    cancel() {
      this.$router.push({name: 'Home'})
    },
    onPage(event: any) {
      this.lazyParams = event;
      this.loadData();
    },
    onSort(event: any) {
      this.lazyParams = event;
      this.loadData();
    },
    onInput: debounce(function (this: any, event: any) {
      this.inputText = event
    }, 500),
    onFilter() {
      // @ts-ignore
      this.lazyParams.filters = this.filters;
      this.loadData();
    },
  },
  beforeMount() {
    scrollToTop()
  }
})
;
